/* ============================================================
   Mega menu — Lenis passthrough + position correction
   ------------------------------------------------------------
   Two unrelated defects, one file.

   1. SCROLL. nsh-smooth-scroll.js runs Lenis (window.__nshLenis)
      with wrapper:window. Lenis intercepts wheel events and
      scrolls the page programmatically, so a wheel aimed at the
      mega panel moves the document instead. Lenis skips any
      subtree marked data-lenis-prevent.

   2. POSITION. header-2.js writes viewport-relative coordinates
      into mega.style.top / mega.style.left. Those coordinates
      are resolved against the transformed header section, not
      the viewport, so the panel lands offset by the section's
      own top edge.

   The position correction runs on class AND style mutations, so
   load order relative to header-2.js does not matter.
   ============================================================ */

(function () {
  'use strict';

  var MOBILE_BP = 768;
  var EDGE_FALLBACK = 12;
  var OFFSET_FALLBACK = 4;

  function numberFromVar(styles, name, fallback) {
    var parsed = parseInt(styles.getPropertyValue(name), 10);
    return isNaN(parsed) ? fallback : parsed;
  }

  /* Where does a position:fixed element with top:0;left:0 land
     inside this parent? Zero unless a transformed ancestor has
     hijacked the containing block. */
  function fixedOrigin(parent) {
    var probe = document.createElement('div');
    probe.style.cssText =
      'position:fixed;top:0;left:0;width:0;height:0;display:block;visibility:hidden;pointer-events:none;';
    parent.appendChild(probe);
    var rect = probe.getBoundingClientRect();
    parent.removeChild(probe);
    return rect;
  }

  function reposition(mega) {
    if (window.innerWidth <= MOBILE_BP) return;

    var item = mega.closest('[data-nav-item]');
    if (!item) return;

    var header = mega.closest('.mega-header');
    if (!header) return;

    var styles = getComputedStyle(mega);
    var offset = numberFromVar(styles, '--mm-offset', OFFSET_FALLBACK);
    var edge = numberFromVar(styles, '--mm-edge', EDGE_FALLBACK);

    var origin = fixedOrigin(mega.parentNode);
    var headerRect = header.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    var width = mega.offsetWidth || 600;

    var targetTop = headerRect.bottom + offset;
    var targetLeft = itemRect.left + itemRect.width / 2 - width / 2;

    if (targetLeft < edge) {
      targetLeft = edge;
    }
    if (targetLeft + width > window.innerWidth - edge) {
      targetLeft = window.innerWidth - edge - width;
    }

    var topValue = targetTop - origin.top + 'px';
    var leftValue = targetLeft - origin.left + 'px';

    /* Only write when the value actually changes, so the
       observer below does not retrigger itself. */
    if (mega.style.top !== topValue) {
      mega.style.top = topValue;
    }
    if (mega.style.left !== leftValue) {
      mega.style.left = leftValue;
    }
    if (mega.style.right !== 'auto') {
      mega.style.right = 'auto';
    }

    item.style.setProperty(
      '--mm-bridge-h',
      Math.max(0, targetTop - itemRect.bottom) + 'px'
    );
  }

  function init() {
    var megas = document.querySelectorAll('[data-nav-item].has-mega [data-mega]');
    if (!megas.length) return;

    /* Tell Lenis to leave the panel's scroller alone. */
    megas.forEach(function (mega) {
      var inner = mega.querySelector('.mega-menu__inner');
      if (inner && !inner.hasAttribute('data-lenis-prevent')) {
        inner.setAttribute('data-lenis-prevent', '');
      }
    });

    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        var mega = record.target;
        if (mega.classList.contains('is-visible')) {
          reposition(mega);
        }
      });
    });

    megas.forEach(function (mega) {
      observer.observe(mega, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    });

    var frame = null;
    var onViewportChange = function () {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        megas.forEach(function (mega) {
          if (mega.classList.contains('is-visible')) {
            reposition(mega);
          }
        });
      });
    };

    window.addEventListener('scroll', onViewportChange, { passive: true });
    window.addEventListener('resize', onViewportChange, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.mega-header')) {
      init();
    }
  });
})();